var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"d1 bng"}),_c('div',{staticClass:"d1"},[(_vm.getLoginStep == 0)?_c('inForm'):_vm._e(),(_vm.getLoginStep == 1)?_c('registerStepOne',{on:{"next":_vm.regNext}}):_vm._e(),(_vm.getLoginStep == 2)?_c('registerStepTwo',{attrs:{"obj":_vm.formObj}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }